import { render } from "./CardRowUnidade.vue?vue&type=template&id=35c51298&scoped=true"
import script from "./CardRowUnidade.vue?vue&type=script&lang=js"
export * from "./CardRowUnidade.vue?vue&type=script&lang=js"

import "./CardRowUnidade.vue?vue&type=style&index=0&id=35c51298&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c51298"]])

export default __exports__